const ResumeTypes = {
    FETCH_START:    '[HOSTESS][RESUME] FETCH START',
    FETCH_SUCCESS:  '[HOSTESS][RESUME] FETCH SUCCESS',
    FETCH_FAILURE:  '[HOSTESS][RESUME] FETCH FAILURE'
};

export default ResumeTypes;